webpackJsonp([155849247502049],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(87);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Icon = __webpack_require__(14);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Blocks = __webpack_require__(34);
	
	var _Blocks2 = _interopRequireDefault(_Blocks);
	
	var _Banners = __webpack_require__(11);
	
	var _helperFunctions = __webpack_require__(7);
	
	var _graphql = __webpack_require__(56);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This template: All News articles
	var Story = function (_React$Component) {
	  _inherits(Story, _React$Component);
	
	  function Story(props) {
	    _classCallCheck(this, Story);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Story.prototype.componentDidMount = function componentDidMount() {
	    var links = [].slice.call(document.querySelectorAll(".text-block__container a"));
	    links.map(function (l) {
	      return l.setAttribute("target", "_blank");
	    });
	  };
	
	  Story.prototype.render = function render() {
	    var data = this.props.data;
	
	    var page = data.mortyStory;
	    var blocks = page.childrenMortyBlock.map(function (b) {
	      return _react2.default.createElement(_Blocks2.default, { key: b.id, block: b });
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "news-story mb3 mb4-l" },
	      _react2.default.createElement(_Meta2.default, { page: page }),
	      _react2.default.createElement(_Banners.BackBannerBlockNews, { page: page }),
	      _react2.default.createElement(
	        "div",
	        { className: "w-calc-64 mw-696 center" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex jusitfy-start items-center pv2" },
	          _react2.default.createElement(_Icon2.default, { path: "icon-18-news", width: "16", height: "17", className: "mr1" }),
	          _react2.default.createElement(
	            "h4",
	            { className: "h-4 ttu" },
	            page.publishedDate && (0, _helperFunctions.formatDate)(page.publishedDate)
	          )
	        ),
	        blocks
	      )
	    );
	  };
	
	  return Story;
	}(_react2.default.Component);
	
	exports.default = Story;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var previewQuery = exports.previewQuery = "\n  query Story($id: String!) {\n    mortyStory(id: { eq: $id }) {\n      title\n      route\n      subtitle\n      publishedDate\n      abstract\n      metaTitle\n      metaDescription\n      metaKeywords\n      abstractPhotoAltText\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n      abstractPhoto {\n        url\n      }\n      childrenMortyBlock {\n        id\n        blockType\n        content\n        headline\n        subheadline\n        buttonUrl\n        buttonTitle\n        format\n        caption\n        subcaption\n        url\n        attribution\n        focalPointX\n        focalPointY\n        altText\n        attributionAltText\n        attributionPhoto {\n          url\n        }\n        image {\n          url\n        }\n        videoType\n        videoMinutes\n        embedCode\n        attribution\n        attributionAltText\n        attributionPhoto {\n          url\n        }\n        vistityUrl\n        vistityTitle\n      }\n    }\n  }\n";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-story-js-5d187051cc13cc70382c.js